import axios from 'axios';
import { URLS } from './urls';

const MagentoAPI = axios.create({
    baseURL: URLS.PRODUCT_URL,
    timeout: 10000,
});

export { MagentoAPI };
